import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'React',
                topics: [
                    'Advanced features of Next.js such as automatic code splitting, prefetching, and more',
                    'Techniques for optimizing React rendering performance, including memoization, shouldComponentUpdate, and PureComponent',
                    'GraphQL for querying data in React applications',
                    'React Context API for managing global state in React applications',
                    'React Testing Library for testing React components',
                    'React Native Animation Libraries',
                ],
            },
            {
                title: 'Node.js',
                topics: [
                    'Building RESTful APIs with Node.js',
                    'Real-time communication with WebSockets in Node.js',
                    'Microservices architecture with Node.js',
                    'Techniques for protecting against common attacks such as SQL injection, cross-site scripting, and CSRF',
                    'Authentication and Authorization with Node.js',
                    'Advanced debugging techniques, such as using Node.js Profiler to analyze application performance',
                    'Building machine learning models using popular Node.js libraries such as TensorFlow.js and Brain.js',
                ],
            },
            {
                title: 'TypeScript',
                topics: [
                    'Setting up a TypeScript project with React',
                    'Migrating from JavaScript to TypeScript',
                    'Writing unit tests with Jest and TypeScript',
                    'Handling errors in Express.js and other Node.js web frameworks',
                    'Deploying and scaling TypeScript applications in production environments',
                    'TypeScript Compiler Options and Configuration',
                    'Exploring Decorators in TypeScript',
                ],
            },
            {
                title: 'Web Components',
                topics: [
                    'Shadow DOM for encapsulating styles in Web Components',
                    'Web Components with LitElement',
                    'Web Components with Stencil.js',
                    'Web Components vs. React vs. Vue.js',
                    'Building Web Components with Angular',
                    'Web Components with Svelte',
                    'Web Components for Accessibility',
                ],
            },
            {
                title: 'Progressive Web Apps',
                topics: [
                    'PWA vs. Native App Development',
                    'PWA Performance Optimization Techniques',
                    'PWA Accessibility Best Practices',
                    'PWA and Payment Integration',
                    'PWA Deployment and Hosting',
                    'Building a PWA with React',
                ],
            },
            {
                title: 'Serverless Architecture',
                topics: [
                    'Building Serverless Applications with AWS Lambda',
                    'Serverless vs. Traditional Cloud Infrastructure',
                    'Serverless and Microservices Architecture',
                    'Serverless and IoT Applications',
                    'Serverless and Blockchain',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;